import React from 'react';
import ReactDOM from 'react-dom';

import { StoreContext } from '../../helpers/Store';
import Image from '../Image';

import * as styles from './styles.module.css';

class Lightbox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      moving: false,
    };
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleKeyPress);
  }

  componentDidUpdate(prevProps) {
    const { translate } = this.context;
    let elem;
    let lbStyle = '';

    let { mainImageId, nextImageId, prevImageId } = this.props;

    if (this.state.moving && this.props.visible && this.props.mainImageId === prevProps.nextImageId) {
      lbStyle = styles.movingForwards;
      nextImageId = this.props.mainImageId;
      mainImageId = this.props.prevImageId;
    } else if (this.state.moving && this.props.visible && this.props.mainImageId === prevProps.prevImageId) {
      lbStyle = styles.movingBackwards;
      prevImageId = this.props.mainImageId;
      mainImageId = this.props.nextImageId;
    }

    if (this.props.visible) {
      elem = (
        <div className={styles.lbContainerOuter}>
          <div className={styles.lbContainerInner} onClick={this.handleClose}>
            <button hidden onClick={this.handleClose}>
              {translate('close')}
            </button>
            <Image
              id={mainImageId}
              alt="lightboxImage"
              className={`${styles.lbImage} ${lbStyle}`}
              style={{ padding: '1rem' }}
              images={this.props.images}
            />
            {this.state.moving === 'forwards' && (
              <Image
                id={nextImageId}
                alt="lightboxImage"
                className={`${styles.lbOtherImage} ${styles.movingForwardsOther}`}
                containerProps={{ onAnimationEnd: this.animationStopping }}
                style={{ padding: '1rem' }}
                images={this.props.images}
              />
            )}
            {this.state.moving === 'backwards' && (
              <Image
                id={prevImageId}
                alt="lightboxImage"
                className={`${styles.lbOtherImage} ${styles.movingBackwardsOther}`}
                containerProps={{ onAnimationEnd: this.animationStopping }}
                style={{ padding: '1rem' }}
                images={this.props.images}
              />
            )}
          </div>
          <div
            className={styles.prevButton}
            id="prevButton"
            onClick={this.state.moving ? null : () => this.handleMove('backwards')}
            aria-label={translate('previous')}
            role="button"
            tabIndex={0}
          >
            <i className="entypo icon-left-open" />
          </div>
          <div
            className={styles.nextButton}
            id="nextButton"
            onClick={this.state.moving ? null : () => this.handleMove('forwards')}
            aria-label={translate('next')}
            role="button"
            tabIndex={0}
          >
            <i className="entypo icon-right-open" />
          </div>
        </div>
      );
    } else elem = <div />;

    const modalRoot = document.getElementById('modal-root');
    if (modalRoot) ReactDOM.render(elem, modalRoot);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyPress);
  }

  handleKeyPress = (e) => {
    if (e && e.key === 'Escape') this.handleClose();
  };

  handleClose = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    this.props.onCloseRequest();
  };

  animationStopping = () => {
    this.setState({
      moving: false,
    });
  };

  handleMove = (direction) => {
    this.setState({
      moving: direction,
    });

    if (direction === 'forwards') this.props.onMoveNextRequest();
    else this.props.onMovePrevRequest();
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    return null;
  }
}

Lightbox.contextType = StoreContext;

export default Lightbox;
